export const GOOGLE_ADS_KEYWORD_QUERY_PARAM = 'bk';

function normalizeGoogleAdsKeyword(rawKeyword: string): string {
  return rawKeyword.replace(/\s+/g, ' ').trim().slice(0, 120);
}

export function detectGoogleAdsKeyword(search?: string): string | null {
  if (typeof window === 'undefined' && typeof search !== 'string') {
    return null;
  }

  const params = new URLSearchParams(search ?? window.location.search);
  const utmTerm = normalizeGoogleAdsKeyword(params.get('utm_term') || '');
  const utmSource = (params.get('utm_source') || '').trim().toLowerCase();
  const utmMedium = (params.get('utm_medium') || '').trim().toLowerCase();
  const hasGoogleClickSignal = params.has('gclid') || params.has('gad_source');

  if (!utmTerm) return null;
  if (utmSource === 'google' || utmMedium === 'cpc' || hasGoogleClickSignal) {
    return utmTerm;
  }

  return null;
}

export function addGoogleAdsKeywordParam(params: URLSearchParams, search?: string): void {
  const keyword = detectGoogleAdsKeyword(search);
  if (keyword) {
    params.set(GOOGLE_ADS_KEYWORD_QUERY_PARAM, keyword);
  }
}
